import { Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { isSudoManager } from '../utils/global/helper';
import useUser from '../hooks/global/useUser';
import PageLayout from '../components/global/PageLayout';
import { PLANS } from '../constants/subscriptions';
import PlanCard from '../components/subscriptions/PlanCard';

function PlansPage() {
  const { user } = useUser();
  const [searchParams] = useSearchParams();
  const upsellPlan = searchParams.get('plan');

  useEffect(() => {
    if (upsellPlan) {
      const planCard = document.getElementById(`plan-card-${upsellPlan}`);
      if (planCard) {
        planCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [upsellPlan]);

  return (
    <main>
      <PageLayout
        childContainerProps={{
          sx: {
            maxWidth: '1200px',
          },
        }}
        title="Plans & Pricing"
        isLoading={false}
        guard={{
          isAllowed:
            !!user &&
            (isSudoManager(user) || user.business.type === 'INDEPENDENT'),
        }}>
        <Stack
          direction={{
            xs: 'column',
            md: 'row',
          }}
          gap={{
            xs: 0,
            md: 3,
          }}
          alignItems="stretch"
          pt={4}>
          {PLANS?.map((plan, planIndex) => (
            <PlanCard key={plan.name} plan={plan} planIndex={planIndex} />
          ))}
        </Stack>
      </PageLayout>
    </main>
  );
}

export default PlansPage;
